const DEFAULT_APPOINTMENT_DURATION_CONFIG = {
  version: 1,
  roundToNearestMinutes: 15,
  baseTimes: {
    xs: { brushing: 15, barbe: 30, coupe: 30, couleur: 60, "mèches": 75, lissage: 0, permanente: 0 },
    s: { brushing: 20, barbe: 30, coupe: 45, couleur: 60, "mèches": 90, lissage: 120, permanente: 75 },
    m: { brushing: 30, barbe: 30, coupe: 45, couleur: 60, "mèches": 120, lissage: 160, permanente: 75 },
    l: { brushing: 45, barbe: 30, coupe: 60, couleur: 75, "mèches": 140, lissage: 180, permanente: 90 },
    xl: { brushing: 60, barbe: 30, coupe: 75, couleur: 75, "mèches": 160, lissage: 180, permanente: 120 }
  },
  tables: {
    removeMechesPartielles: {
      xs: { withoutCoupeCouleur: 30, withCoupeCouleur: 45 },
      s: { withoutCoupeCouleur: 20, withCoupeCouleur: 45 },
      m: { withoutCoupeCouleur: 40, withCoupeCouleur: 75 },
      l: { withoutCoupeCouleur: 40, withCoupeCouleur: 95 },
      xl: { withoutCoupeCouleur: 40, withCoupeCouleur: 115 }
    },
    removeCouleurRacines: {
      xs: { remove: 0 },
      s: { remove: 0 },
      m: { remove: 0 },
      l: { remove: 15 },
      xl: { remove: 15 }
    }
  },
  rules: [
    {
      id: "sum-services-excluding-brushing",
      label: "Additionne les services (hors brushing)",
      effect: { kind: "sumSelectedBaseServices", excludeServices: ["brushing"] }
    },
    {
      id: "add-brushing-if-needed",
      label: "Ajoute brushing si pas de coupe complète / pas de permanente / pas barbe seule",
      when: {
        all: [
          {
            any: [
              { kind: "service-not-includes", service: "coupe" },
              { kind: "detail-equals", detail: "coupeDetails", value: "pointes" }
            ]
          },
          { kind: "service-not-includes", service: "permanente" },
          {
            not: {
              all: [
                { kind: "services-count-equals", value: 1 },
                { kind: "service-includes", service: "barbe" }
              ]
            }
          }
        ]
      },
      effect: {
        kind: "adjustByTable",
        table: "baseTimes",
        keys: ["$finalLength", "brushing"],
        factor: 1
      }
    },
    {
      id: "permanente-extra-dry-time",
      label: "Ajoute 30 min de séchage avec permanente sans coupe complète",
      when: {
        all: [
          {
            any: [
              { kind: "service-not-includes", service: "coupe" },
              { kind: "detail-equals", detail: "coupeDetails", value: "pointes" }
            ]
          },
          { kind: "service-includes", service: "permanente" }
        ]
      },
      effect: { kind: "addMinutes", minutes: 30 }
    },
    {
      id: "meches-partielles-without-coupe-couleur",
      label: "Réduction mèches partielles sans combo coupe+couleur",
      when: {
        all: [
          { kind: "service-includes", service: "mèches" },
          { kind: "detail-equals", detail: "mecheDetails", value: "partielles" },
          {
            not: {
              all: [
                { kind: "service-includes", service: "couleur" },
                { kind: "service-includes", service: "coupe" }
              ]
            }
          }
        ]
      },
      effect: {
        kind: "adjustByTable",
        table: "removeMechesPartielles",
        keys: ["$finalLength", "withoutCoupeCouleur"],
        factor: -1
      }
    },
    {
      id: "meches-partielles-with-coupe-couleur",
      label: "Réduction mèches partielles avec combo coupe+couleur",
      when: {
        all: [
          { kind: "service-includes", service: "mèches" },
          { kind: "detail-equals", detail: "mecheDetails", value: "partielles" },
          { kind: "service-includes", service: "couleur" },
          { kind: "service-includes", service: "coupe" }
        ]
      },
      effect: {
        kind: "adjustByTable",
        table: "removeMechesPartielles",
        keys: ["$finalLength", "withCoupeCouleur"],
        factor: -1
      }
    },
    {
      id: "couleur-racines-reduction",
      label: "Réduction couleur racines",
      when: {
        all: [
          { kind: "service-includes", service: "couleur" },
          { kind: "detail-equals", detail: "couleurDetails", value: "racines" }
        ]
      },
      effect: {
        kind: "adjustByTable",
        table: "removeCouleurRacines",
        keys: ["$finalLength", "remove"],
        factor: -1
      }
    }
  ]
};

function resolveKeyToken(token, context) {
  if (typeof token === "string" && token.startsWith("$")) {
    const key = token.substring(1);
    return context[key];
  }
  return token;
}

function lookupValue(root, tokens, context) {
  return tokens.reduce((current, token) => {
    const key = resolveKeyToken(token, context);
    if (!current || key === undefined || key === null) {
      return undefined;
    }
    return current[key];
  }, root);
}

function evaluateCondition(condition, context) {
  if (!condition) {
    return true;
  }

  if (Array.isArray(condition.all)) {
    return condition.all.every((item) => evaluateCondition(item, context));
  }

  if (Array.isArray(condition.any)) {
    return condition.any.some((item) => evaluateCondition(item, context));
  }

  if (condition.not) {
    return !evaluateCondition(condition.not, context);
  }

  if (condition.kind === "service-includes") {
    return context.services.includes(condition.service);
  }

  if (condition.kind === "service-not-includes") {
    return !context.services.includes(condition.service);
  }

  if (condition.kind === "detail-equals") {
    return context.details?.[condition.detail] === condition.value;
  }

  if (condition.kind === "services-count-equals") {
    return context.services.length === Number(condition.value);
  }

  return false;
}

function runEffect(effect, config, context) {
  if (!effect || !effect.kind) {
    return 0;
  }

  if (effect.kind === "sumSelectedBaseServices") {
    const excludeServices = Array.isArray(effect.excludeServices) ? effect.excludeServices : [];
    const baseTimes = config.baseTimes?.[context.finalLength] || {};
    return context.services.reduce((acc, service) => {
      if (excludeServices.includes(service)) {
        return acc;
      }
      return acc + Number(baseTimes[service] || 0);
    }, 0);
  }

  if (effect.kind === "addMinutes") {
    return Number(effect.minutes || 0);
  }

  if (effect.kind === "adjustByTable") {
    const sourceRoot = effect.table === "baseTimes" ? config.baseTimes : config.tables?.[effect.table];
    const lookedUp = lookupValue(sourceRoot, effect.keys || [], context);
    return Number(lookedUp || 0) * Number(effect.factor || 1);
  }

  return 0;
}

export function normalizeAppointmentDurationConfig(rawConfig) {
  if (!rawConfig || typeof rawConfig !== "object") {
    return DEFAULT_APPOINTMENT_DURATION_CONFIG;
  }

  if (!rawConfig.baseTimes || !Array.isArray(rawConfig.rules)) {
    return DEFAULT_APPOINTMENT_DURATION_CONFIG;
  }

  return {
    ...DEFAULT_APPOINTMENT_DURATION_CONFIG,
    ...rawConfig,
    baseTimes: rawConfig.baseTimes,
    tables: rawConfig.tables || {},
    rules: rawConfig.rules
  };
}

export function defaultAppointmentDurationConfig() {
  return JSON.parse(JSON.stringify(DEFAULT_APPOINTMENT_DURATION_CONFIG));
}

export function computeAppointmentDuration(config, input) {
  const normalizedConfig = normalizeAppointmentDurationConfig(config);
  const context = {
    services: Array.isArray(input?.services) ? [...input.services] : [],
    details: input?.details || {},
    finalLength: input?.finalLength
  };

  let total = 0;
  const trace = [];

  normalizedConfig.rules.forEach((rule) => {
    const applies = evaluateCondition(rule.when, context);
    const delta = applies ? runEffect(rule.effect, normalizedConfig, context) : 0;
    total += delta;

    trace.push({
      id: rule.id,
      label: rule.label,
      applied: applies,
      delta,
      runningTotal: total
    });
  });

  const roundTo = Number(normalizedConfig.roundToNearestMinutes || 0);
  const roundedTotal = roundTo > 0 ? Math.round(total / roundTo) * roundTo : total;

  return {
    duration: roundedTotal,
    unroundedDuration: total,
    trace
  };
}
